import CommonStyleEditor from "./CommonStyleEditor";
import { useState } from "react";
import { HeaderItemsQueries } from "../../../../../../requests/queries/HeaderItems";
import ColorPicker from "../picker/ColorPicker";

export default function HeaderCellProperties({ cell, onChange, pages }) {

    const [newItem, setNewItem] = useState({text: '', link_to: '', action_log: ''});

    const addItem = async () => {
        const item = await HeaderItemsQueries.createItem(cell.header_cell_id, newItem);
        onChange(cell.cell_id, {items: [...cell.items, item]});
        setNewItem({text: '', link_to: '', action_log: ''});
    }

    return (
        <div className="property-section">
            <div className="property-row">
                <div className="property-label">Couleur du texte</div>
                <ColorPicker value={cell.styles_properties?.text_color || '#000000'} onChange={(color) => onChange(cell.cell_id, {styles_properties: {...cell.styles_properties, text_color: color}, type: cell.type})}/>
            </div>
            <div className="property-section-title">Header</div>
            <div className="property-row">
                <div className="property-label">Ajouter un item</div>
                <input placeholder="Texte" className="property-input property-input-small" type="text" value={newItem.text} onChange={(e) => setNewItem({...newItem, text: e.target.value})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Link to</div>
                <select className="property-input property-input-small" value={newItem.link_to} onChange={(e) => setNewItem({...newItem, link_to: e.target.value})}>
                    <option value="">Aucune</option>
                    {pages.filter((page) => page.id !== cell.page_id).map((page) => (
                        <option key={page.id} value={page.id}>{page.name}</option>
                    ))}
                </select>
            </div>
            <div className="property-row">
                <div className="property-label">Action log</div>
                <input className="property-input property-input-small" type="text" value={newItem.action_log} onChange={(e) => setNewItem({...newItem, action_log: e.target.value})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Ajouter</div>
                <button className="property-button-add" onClick={addItem}>+</button>
            </div>
            <CommonStyleEditor cell={cell} onChange={onChange}/>
        </div>
    )
}